import React from 'react';
import Products from '../../features/store/products/Products';

function ProductsView() {
  return (
    <Products />
  );
}

export default ProductsView;